export function mapOtpSendError(err: unknown): string {
  const msg = (err as any)?.message?.toString?.() ?? '';
  const status = (err as any)?.status;
  const code = (err as any)?.code || '';
  if (status === 429 || /over_email_send_limit|over_email_send_rate_limit|rate|wait/i.test(msg) || /over_email_send_rate_limit/i.test(code)) {
    return 'Too many attempts — wait 60 seconds and try again.';
  }
  if (/network|fetch/i.test(msg)) return 'Network error. Please try again.';
  return 'Something went wrong. Please try again.';
}

export function mapOtpVerifyError(err: unknown): string {
  const msg = (err as any)?.message?.toString?.() ?? '';
  const status = (err as any)?.status;
  const code = (err as any)?.code || '';
  if (/expired|invalid/i.test(msg)) return 'Invalid or expired code. Please try again.';
  if (status === 429 || /rate|over_email_send_limit|over_email_send_rate_limit/i.test(msg) || /over_email_send_rate_limit/i.test(code))
    return 'Too many attempts — wait 60 seconds and try again.';
  if (/network|fetch/i.test(msg)) return 'Network error. Please try again.';
  return 'Something went wrong. Please try again.';
}

export function mapJoinError(err: unknown): string {
  const msg = (err as any)?.message?.toString?.() ?? '';
  if (/first name/i.test(msg)) return "We couldn't save your first name. Please try again.";
  if (/invalid|used|expired/i.test(msg))
    return "This invite link doesn't work anymore. Ask for a new one.";
  if (/network|fetch/i.test(msg)) return 'Network error. Please try again.';
  return 'Something went wrong. Please try again.';
}

export function mapPushSaveError(): string {
  return 'We could not save your notification subscription. Please try again.';
}

